import { useAdminPremiumSetupBanner } from '@ms/yammer-web-components/dist/adminPremiumSetupBanner';
import { useLeadershipCornerBanner } from '@ms/yammer-web-components/dist/leadershipCorner/LeadershipCornerBanner';
import { useOutageBanner } from '@ms/yammer-web-components/dist/outageBanner/hooks';
import { useRebrandingBanner } from '@ms/yammer-web-components/dist/rebrandingBanner';
import Flex, { FlexItem } from '@ms/yammer-web-core-ui/dist/components/Flex';
import React, { useCallback } from 'react';

export const useGetBannersCallback = () => {
  const outageBanner = useOutageBanner();
  const rebrandingBanner = useRebrandingBanner();
  const adminPremiumSetupBanner = useAdminPremiumSetupBanner();
  const leadershipCornerBanner = useLeadershipCornerBanner();

  return useCallback(() => {
    const hasAnyBanner = outageBanner || rebrandingBanner || adminPremiumSetupBanner || leadershipCornerBanner;
    const outageBannerContent = outageBanner ? <FlexItem>{outageBanner}</FlexItem> : null;
    const rebrandingBannerContent = rebrandingBanner ? <FlexItem>{rebrandingBanner}</FlexItem> : null;
    const adminPremiumSetupBannerContent = adminPremiumSetupBanner ? (
      <FlexItem>{adminPremiumSetupBanner}</FlexItem>
    ) : null;
    const leadershipCornerBannerContent = leadershipCornerBanner ? <FlexItem>{leadershipCornerBanner}</FlexItem> : null;
    const renderContent = hasAnyBanner ? (
      <Flex grow={1} direction="column">
        {outageBannerContent}
        {rebrandingBannerContent}
        {adminPremiumSetupBannerContent}
        {leadershipCornerBannerContent}
      </Flex>
    ) : null;

    return renderContent;
  }, [outageBanner, rebrandingBanner, adminPremiumSetupBanner, leadershipCornerBanner]);
};
